module.exports = __webpack_public_path__ + "static/media/logo_spl.8eb46c75.png";